import React from 'react';
import {
  Container,
  InputContainer,
  Label
} from './styles';

const renderBottomElement = (Element) => {
  if(typeof Element === 'function') {
    return () => Element();
  }

  return <Element />;
}

export function BaseInput({
  label = 'Label',
  renderBottomElement = () => null,
  children,
  fluid = true,
  minWidth = '20rem',
  ...props
}) {
  return (
    <Container fluid={fluid} minWidth={minWidth}>
      <Label>{label}</Label>
      <InputContainer {...props} fluid={fluid}>
        {children}
      </InputContainer>
      {renderBottomElement()}
    </Container>
  );
}